import { generateResourceReducer } from '../generators/resource.reducer';
import * as types from './project-task.types';
import * as constants from './project-task.constants';

export const projectTaskReducer = generateResourceReducer<types.IProjectTask>({
  STORE: constants.STORE_PROJECT_TASK,
  CLEAR: constants.CLEAR_PROJECT_TASK,
});
